module.exports = __webpack_public_path__ + "img/practical-fixer.a74f6913.svg";